import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../components/loader.jsx';
import connect from './connect';
import { routeToTerm } from '../actions/route';
import { selectCurrentTerm } from '../selectors/terms.js';
import { loadTerms } from 'actions/terms';
import { createStructuredSelector } from 'reselect';

class Root extends React.Component {
    static displayName = 'Root';

    static propTypes = {
        routeToTerm: PropTypes.func.isRequired,
        term: PropTypes.shape({
            id: PropTypes.number,
        }),
        children: PropTypes.node,
    };

    state = { loaded: false };

    async componentDidMount() {
        const { loadTerms } = this.props;
        await loadTerms();
        this.setState({ loaded: true });
    }

    componentDidUpdate() {
        const {
            term: { id },
            routeToTerm,
        } = this.props;
        const { loaded } = this.state;
        loaded && routeToTerm({ termId: id, routeType: 'replace' });
    }

    render() {
        return <Loader message="Loading terms..." />;
    }
}

export default connect(
    createStructuredSelector({
        term: selectCurrentTerm,
    }),
    {
        loadTerms,
        routeToTerm,
    }
)(Root);



// WEBPACK FOOTER //
// ./src/components/root.jsx